export default __webpack_public_path__ + "static/KeywordResearch_02_01@2x-16551d6905634372597177fa0851ea1f.png";